export default import.meta.ROLLDOWN_FILE_URL__LFg2llZOV8q9D9gZqRKNg